<div class="modal-header">
    <h2 class="modal-title">{{ azione }} manutenzione</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
        <ngb-panel id="tab-1" title="Anagrafica Manutenzione">
            <ng-template ngbPanelContent>
                <form class="form" role="form" [formGroup]="criteriaForm">
                    <div class="form-row">
                        <div class="form-group col-md-4">
                            <label for="idTipoIntervento">Tipo intervento</label>
                            <select class="form-control" formControlName="idTipoIntervento" id="idTipoIntervento">
                                <option [ngValue]="null">Seleziona un'opzione...</option>
                                <option *ngFor="let item of datalist.tipologiaIntervento" [ngValue]="item.id">{{ item.descrizione }}</option>
                            </select>
                        </div>
                        <div class="form-group col-md-4">
                            <app-toolkit-datepicker
                                id="dataPrevista"
                                label="Data prevista"
                                formControlName="dataPrevista"
                                [disabled]="criteriaForm.controls['dataPrevista'].disabled">
                            </app-toolkit-datepicker>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="enteManutentore">Ente manutentore</label>
                            <input class="form-control" id="enteManutentore" formControlName="enteManutentore" type="text">
                        </div>
                        <div class="form-group col-md-4">
                            <app-toolkit-datepicker
                                id="dataEsecuzione"
                                label="Data esecuzione"
                                formControlName="dataEsecuzione"
                                [disabled]="criteriaForm.controls['dataEsecuzione'].disabled">
                            </app-toolkit-datepicker>
                        </div>
                        <div class="form-group col-md-4">
                            <label for="vitaUtile">Vita utile</label>
                            <input class="form-control" id="vitaUtile" formControlName="vitaUtile" type="text">
                        </div>
                        <div class="form-group col-md-4">
                            <app-toolkit-datepicker
                                id="dataProssimaManutenzione"
                                label="Data prossima manutenzione"
                                formControlName="dataProssimaManutenzione"
                                [disabled]="criteriaForm.controls['dataProssimaManutenzione'].disabled">
                            </app-toolkit-datepicker>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="descrizione">Descrizione</label>
                            <textarea class="form-control" id="descrizione" formControlName="descrizione"></textarea>
                        </div>
                        <div class="form-group col-md-12">
                            <label for="note">Note</label>
                            <textarea class="form-control" id="note" formControlName="note"></textarea>
                        </div>
                    </div>
                </form>
            </ng-template>
        </ngb-panel>
        <ngb-panel *ngIf="azione !== 'Aggiungi'" id="tab-2" title="Documenti manutenzione">
            <ng-template ngbPanelContent>
                <h6 id="table_documentoManutenzioneList">Elenco documenti manutenzione</h6>
                <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                    <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_documentoManutenzioneList">
                        <thead class="thead-light">
                            <tr>
                                <th scope="col">ID</th>
                                <th scope="col">Nome documento</th>
                                <th scope="col">Classe documento</th>
                                <th scope="col">Didascalia</th>
                                <th scope="col">Data inserimento</th>
                                <th scope="col">Visibilità</th>
                                <th scope="col"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of items">
                                <td>{{ item.idDocumento }}</td>
                                <td>{{ item.nomeDocumento }}</td>
                                <td>{{ item.idClasseDocumento | anagraficaClasseDocumento: (datalist.classeDocumento || []) }}</td>
                                <td>{{ item.didascalia }}</td>
                                <td>{{ item.createdAt | date: 'dd/MM/yyyy' }}</td>
                                <td>{{ item.docPublic === 0 ? 'Privato' : 'Pubblico' }}</td>
                                <td class="actions">
                                    <button aria-label="scarica il documento" type="button" class="btn btn-xs btn-link" container="body" (click)="documentoManutenzioneDownload(item)" ngbTooltip="Scarica il documento">
                                        <app-toolkit-bl-icon icon="download" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                                    </button>
                                    <button aria-label="modifica" *ngIf="canEdit" type="button" class="btn btn-xs btn-link" container="body" (click)="editItem(item)" ngbTooltip="Modifica">
                                        <app-toolkit-bl-icon icon="pencil" cssClass="icon icon-sm icon-secondary"></app-toolkit-bl-icon>
                                    </button>
                                    <button aria-label="elimina" *ngIf="canEdit" type="button" class="btn btn-xs btn-link" container="body" (click)="deleteItem(item.idDocumento)" ngbTooltip="Elimina">
                                        <app-toolkit-bl-icon icon="close" cssClass="icon icon-sm icon-danger"></app-toolkit-bl-icon>
                                    </button>
                                </td>
                            </tr>
                            <tr *ngIf="!items.length">
                                <td colspan="7"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div *ngIf="canEdit" class="button-actions">
                    <button type="button" class="btn btn-outline-primary" (click)="addItem()">
                        <app-toolkit-bl-icon icon="plus" cssClass="icon icon-sm icon-primary"></app-toolkit-bl-icon>
                        Aggiungi
                    </button>
                </div>
            </ng-template>
        </ngb-panel>
    </ngb-accordion>
    <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button *ngIf="canEdit" type="button" tabindex="0" (click)="saveManutenzione()" class="btn btn-primary">Salva</button>
</div>